export default __webpack_public_path__ + "static/simvent-img-2-dac423f0e6cc4e598daa5ba848cf5370.png";